module.exports = {
    returnName: {
        1: 'PendenteLiberacao',
        2: 'Ativo',
        3: 'Inativo',
    },

    returnNameFormatted: {
        1: 'Pendente de Liberacão',
        2: 'Ativo',
        3: 'Inativo',
    },
    returnId: {
        PendenteLiberacao: 1,
        Ativo: 2,
        Inativo: 3,
    },
    returnNameForName: {
        PendenteLiberacao: 'PendenteLiberacao',
        Ativo: 'Ativo',
        Inativo: 'Inativo',
    },
    returnNameForTab: {
        PendenteLiberacao: 'PendenteLiberacao',
        Ativo: 'Ativo',
        Inativo: 'Inativo',
        Todas: 'Todas',
    },
    returnTabForName: {
        PendenteLiberacao: 'PendenteLiberacao',
        Ativo: 'Ativo',
        Inativo: 'Inativo',
        Todas: 'Todas',
    },
    returnNameFormattedForName: {
        PendenteLiberacao: 'Pendente de Liberacão',
        Ativo: 'Ativo',
        Inativo: 'Inativo',
    },
};
